import { useQuery } from "@tanstack/react-query";

interface UsageStatus {
  plan_name: string;
  unlimited: boolean;
  daily_used: number;
  daily_limit: number;
  daily_remaining: number | null;
  monthly_used: number;
  monthly_limit: number;
  monthly_remaining: number | null;
  has_notes_left: boolean;
  is_trial: boolean;
  trial_days_remaining: number | null;
  trial_ends_at?: string | null;
}

export function useUsageStatus() {
  return useQuery<UsageStatus>({
    queryKey: ["usage-status"],
    queryFn: async () => {
      const res = await fetch("/api/subscriptions/get-usage-status/", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (!res.ok) throw new Error("Fehler beim Laden des Usage-Status");
      return res.json();
    },
    staleTime: 0, // nie zwischenspeichern → immer aktuell
    refetchOnWindowFocus: true,
  });
}
